// About.jsx
import React,{useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AzyByteTechLanding.css';
import azimimg from '../assets/azimimg.png';
import azybytelogo from '../assets/azybytelogo.png';
import meetimg from '../assets/meet.png'
import Navbar from './Navbar';
import Footer from './Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import saniya from '../assets/saniya.jpg';
import aksha from '../assets/aksha.jpg';
import ahmed from '../assets/ahm.jpeg';
import krishil from '../assets/krishilimg.jpg';
import userprofile from '../assets/userprofile.png';
import { Helmet } from 'react-helmet-async';

function About() {

    useEffect(() => {
      AOS.init({
        duration: 1000,
        once: true,
        offset: 100,
      });
    }, []);

  return (
    <div>
      <Helmet>
        <title>
          About AzyByte Technologies | Web Development & Software Solutions
        </title>

        <meta
          name="description"
          content="Learn about AzyByte Technologies, our mission, team, and expertise in web development, software engineering, AI automation, mobile applications, and digital transformation."
        />

        <meta
          name="keywords"
          content="About AzyByte Technologies, AzyByte Team,AzyByte Technologies, Software company nadiad, Web Development Nadiad, AI Automation Experts"
        />

        <link
          rel="canonical"
          href="https://www.azybyte.in/about"
        />

        <meta
          property="og:title"
          content="About AzyByte Technologies"
        />

        <meta
          property="og:description"
          content="Meet the team behind AzyByte Technologies and discover our expertise in software development, AI automation, and digital solutions."
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:url"
          content="https://www.azybyte.in/about"
        />

        <meta
          property="og:image"
          content="https://www.azybyte.in/azybytelogo.png"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "AzyByte Technologies",
            url: "https://www.azybyte.in",
            logo: "https://www.azybyte.in/azybytelogo.png",
            description:
              "AzyByte Technologies provides web development, software engineering, AI automation, and digital transformation solutions.",
            sameAs: [
              "https://www.linkedin.com/company/azybytetechnologies",
              "https://instagram.com/azybytetech"
            ]
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "About AzyByte Technologies",
            url: "https://www.azybyte.in/about",
            description:
              "Learn about AzyByte Technologies, our team, mission, and technology expertise."
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            name: "Azim Shaikh",
            jobTitle: "Founder",
            worksFor: {
              "@type": "Organization",
              name: "AzyByte Technologies"
            }
          })}
        </script>
      </Helmet>
      <Navbar></Navbar>

      {/* Page Header */}
      <section className="bg-light py-5 mt-5">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h1 className="fw-bold mb-3">About AzyByte Technologies</h1>
              <p className="lead mb-0">
                We're a team of passionate tech experts dedicated to helping businesses
                succeed in the digital world.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="py-5">
        <div className="container py-4">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src={azybytelogo}
                alt="Our Story"
                className="img-fluid rounded shadow-sm"
                data-aos="flip-left"
              />
            </div>
            <div className="col-lg-6">
              <h2 className="fw-bold mb-3">Our Story</h2>
              <p className="mb-3">
                Founded in 2026, AzyByte began with a simple mission: to make cutting-edge
                technology accessible to businesses of all sizes. Our founder, with decades of
                combined experience in software development and IT consulting, recognized a gap
                in the market for technology solutions that were both innovative and practical.
              </p>
              <p className="mb-3">
                What started as a small team of three passionate technologists has grown into a
                full-service technology IT agency with expertise across web development, mobile
                applications, cloud solutions, UI/UX design, and IT consultancy.
              </p>
              <p className="mb-0">
                Throughout our growth, we've remained committed to our core values of innovation,
                quality, and client satisfaction. We believe that technology should empower
                businesses, not complicate them, and this philosophy guides everything we do.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="row">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="card border-0 h-100 shadow-sm" data-aos="flip-down">
                <div className="card-body p-4">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-bullseye text-primary"></i>
                  </div>
                  <h3 className="fw-bold mb-3">Our Mission</h3>
                  <p className="mb-0">
                    To empower businesses with innovative technology solutions that drive growth,
                    enhance efficiency, and create competitive advantages in an increasingly
                    digital world. We aim to be more than just a service provider; we want to be
                    a strategic partner in our clients' success journeys.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card border-0 h-100 shadow-sm" data-aos="flip-up">
                <div className="card-body p-4">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-eye text-primary"></i>
                  </div>
                  <h3 className="fw-bold mb-3">Our Vision</h3>
                  <p className="mb-0">
                    To be the leading technology solutions provider known for innovation, excellence,
                    and client satisfaction. We envision a future where every business, regardless
                    of size or industry, can harness the full potential of technology to achieve
                    their goals and make a positive impact in their respective fields.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="py-5">
        <div className="container py-4">
          <div className="row mb-5 justify-content-center">
            <div className="col-lg-6 text-center">
              <h2 className="fw-bold mb-3">Our Core Values</h2>
              <p className="mb-0">
                These principles guide our work and define our culture at AzyByte.
              </p>
            </div>
          </div>

          <div className="row g-4">
            <div className="col-md-4" data-aos="fade-right">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-lightbulb text-primary"></i>
                  </div>
                  <h5 className="card-title">Innovation</h5>
                  <p className="card-text">
                    We continuously explore new technologies and approaches to deliver innovative
                    solutions that keep our clients ahead of the curve.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4" data-aos="fade-right">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-award text-primary"></i>
                  </div>
                  <h5 className="card-title">Excellence</h5>
                  <p className="card-text">
                    We are committed to delivering exceptional quality in everything we do, from
                    code quality to client communication.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4" data-aos="fade-right">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-people text-primary"></i>
                  </div>
                  <h5 className="card-title">Collaboration</h5>
                  <p className="card-text">
                    We believe in the power of teamwork – both within our team and in partnership
                    with our clients – to achieve exceptional results.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4" data-aos="fade-left">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-heart text-primary"></i>
                  </div>
                  <h5 className="card-title">Integrity</h5>
                  <p className="card-text">
                    We operate with honesty, transparency, and ethical standards in all our
                    business dealings and relationships.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4" data-aos="fade-left">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-graph-up text-primary"></i>
                  </div>
                  <h5 className="card-title">Results-Driven</h5>
                  <p className="card-text">
                    We focus on delivering measurable results that contribute directly to our
                    clients' business objectives and success.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4" data-aos="fade-left">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-stars text-primary"></i>
                  </div>
                  <h5 className="card-title">Client-Centric</h5>
                  <p className="card-text">
                    We put our clients' needs at the center of everything we do, ensuring that our
                    solutions address their unique challenges and goals.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    {/* <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="row mb-5 justify-content-center">
            <div className="col-lg-6 text-center">
              <h2 className="fw-bold mb-3">Our Leadership Team</h2>
              <p className="mb-0">
                Meet the experienced professionals who guide our vision and operations.
              </p>
            </div>
          </div>

          <div className="row g-4">

            <div className="col-lg-4 col-md-6" data-aos="fade-up">
              <div className="card border-0 shadow-sm h-100">
                <div className="team-img-container">
                  <img src={azimimg} className="card-img-top team-img" alt="Azim Shaikh" />
                </div>
                <div className="card-body p-4 text-center d-flex flex-column">
                  <h5 className="card-title mb-1">Azim Shaikh</h5>
                  <p className="text-primary mb-3 small fw-bold">Head @AzyByte - Technical Project Manager</p>
                  <p className="card-text mb-4 flex-grow-1">
                    With over 4+ years of experience in software development and IT leadership,
                    Azim brings vision and strategic direction to AzyByte Technologies with expertise
                    in Software Development, CyberSecurity and Ethical Hacking.
                  </p>
                  <div className="social-icons mt-auto">
                  </div>
                </div>
              </div>
            </div>


            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="card border-0 shadow-sm h-100">
                <div className="team-img-container">
                  <img src={userprofile} className="card-img-top team-img" style={{objectFit:"contain"}} alt="clarence parmar" />
                </div>
                <div className="card-body p-4 text-center d-flex flex-column">
                  <h5 className="card-title mb-1">Clarence Parmar</h5>
                  <p className="text-primary mb-3 small fw-bold">Cyber Security Analyst & Ethical Hacker (Tech Lead)</p>
                  <p className="card-text mb-4 flex-grow-1">
                    Clarence is our cybersecurity specialist, skilled in ethical hacking and digital security. He proactively identifies vulnerabilities,
                    protects client data, and ensures our solutions remain secure against evolving threats.
                  </p>
                </div>
              </div>
            </div> */}


            {/* <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
              <div className="card border-0 shadow-sm h-100">
                <div className="team-img-container">
                  <img src={meetimg} className="card-img-top team-img" alt="TPM" />
                </div>
                <div className="card-body p-4 text-center d-flex flex-column">
                  <h5 className="card-title mb-1 text-muted">Meet Thakkar</h5>
                  <p className="text-primary mb-3 small fw-bold">Senior Full Stack Developer(MERN/MEAN)</p>
                  <p className="card-text mb-4 flex-grow-1">
                    Expertise in emerging technologies and software architecture ensures
                    our technical solutions are innovative and scalable. With 3.5+ years
                    of experience making businesses scalable.
                  </p>
                </div>
              </div>
            </div> */}


            {/* Saniya Shaikh */}
            {/* <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="card border-0 shadow-sm h-100">
                <div className="team-img-container">
                  <img src={saniya} className="card-img-top team-img" alt="Saniya Shaikh" />
                </div>
                <div className="card-body p-4 text-center d-flex flex-column">
                  <h5 className="card-title mb-1">Saniya Shaikh</h5>
                  <p className="text-primary mb-3 small fw-bold">BDM (Business Development Manager)</p>
                  <p className="card-text mb-4 flex-grow-1">
                    Saniya's focus on client satisfaction and project delivery excellence ensures
                    that we consistently exceed client expectations and maintain strong professional relationships.
                  </p>
                  <div className="social-icons mt-auto">

                  </div>
                </div>
              </div>
            </div> */}

            {/* <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="card border-0 shadow-sm h-100">
                <div className="team-img-container">
                  <img src={aksha} className="card-img-top team-img" alt="Aksha vahora" />
                </div>
                <div className="card-body p-4 text-center d-flex flex-column">
                  <h5 className="card-title mb-1">Aksha Vahora</h5>
                  <p className="text-primary mb-3 small fw-bold">PHP Developer</p>
                  <p className="card-text mb-4 flex-grow-1">
                   Passionate PHP developer focused on creating fast, secure, and scalable web solutions.
                    Experienced in building robust backend systems, integrating APIs, and turning ideas into reliable digital products.
                  </p>

                  <div className="social-icons mt-auto">

                  </div>
                </div>
              </div>
            </div> */}

            {/* <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="card border-0 shadow-sm h-100">
                <div className="team-img-container">
                  <img src={ahmed} className="card-img-top team-img" alt="team member" />
                </div>
                <div className="card-body p-4 text-center d-flex flex-column">
                  <h5 className="card-title mb-1">Ahmed Momin</h5>
                  <p className="text-primary mb-3 small fw-bold">IoT and Embedded Systems</p>
                  <p className="card-text mb-4 flex-grow-1">
                    Our IoT and Embedded developer specializes in building smart, connected systems with a focus on reliability and performance.
                    He develops efficient hardware-software integrations, ensuring seamless communication, scalability, and secure device functionality across all solutions.
                  </p>
                  <div className="social-icons mt-auto">

                  </div>
                </div>
              </div>
            </div>
          <div className='row justify-content-center mx-auto mt-4'>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="card border-0 shadow-sm h-100">
                <div className="team-img-container">
                  <img src={krishil} className="card-img-top team-img" alt="team member" />
                </div>
                <div className="card-body p-4 text-center d-flex flex-column">
                  <h5 className="card-title mb-1">Krishil Agarwal</h5>
                  <p className="text-primary mb-3 small fw-bold">AI/ML Engineer - Automation</p>
                  <p className="card-text mb-4 flex-grow-1">
                    Our AI/ML Engineer specializes in developing intelligent automation solutions, AI agents, and scalable machine learning systems.
    With expertise in LangChain, LangSmith, LLM integrations, and workflow automation, he builds smart applications that streamline business operations.
                  </p>
                  <div className="social-icons mt-auto">

                  </div>
                </div>
              </div>
            </div>
          </div>

          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="py-5">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="fw-bold mb-3">Join Our Team</h2>
              <p className="lead mb-4">
                We're always looking for talented individuals who share our passion for technology
                and innovation. Reach out for current openings or send us your resume.
              </p>
              <a href="mailto:contact@azybyte.in" className="btn btn-primary btn-lg px-5">Get Connected</a>
            </div>
          </div>
        </div>
      </section>

      <Footer></Footer>

    </div>
  );
}

export default About;